import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowDownRight.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(n, { ref: e, ...t, weights: a }));
r.displayName = "ArrowDownRightIcon";
const w = r;
export {
  w as ArrowDownRight,
  r as ArrowDownRightIcon
};
